export default __webpack_public_path__ + "static/media/USAworldwideTravelMissionary.6518dd13.jpg";